"use client";
import React from "react";
import { FaWhatsapp } from "react-icons/fa6";
import {
  Bed,
  Binoculars,
  CarFront,
  Coffee,
  MapPin,
  Phone,
  Ticket,
} from "lucide-react";
import Link from "next/link";
import { IPackageDetailsData } from "../interface/IPackageDetails.interface";
import { useSession } from "next-auth/react";
import { useModal } from "@/core/context/ModalContext";
import { showErrorMessage } from "@/utils/toastMessage/toast.message";

interface IProps {
  packageData?: IPackageDetailsData;
}
const packageDetail = [
  {
    id: 1,
    icon: Bed,
    label: "Hotel",
  },
  {
    id: 2,
    icon: Binoculars,
    label: "SightSeeing",
  },
  {
    id: 3,
    icon: CarFront,
    label: "Transfer",
  },
  {
    id: 4,
    icon: Coffee,
    label: "Breakfast",
  },
];
const BookNowSection: React.FC<IProps> = ({ packageData }) => {
  const { status } = useSession();
  const isLoggedIn = status === "authenticated";

  const { openModal } = useModal();

  const handleNotLoggedIn = () => {
    openModal("login");
    showErrorMessage("Please login to access this feature.");
  };

  return (
    <div className="py-4 px-6 shadow-[0_0_18px_0_#0000000D] rounded-3xl relative flex flex-col gap-20 justify-between md:flex-row">
      <div>
        {/* <Image
          src={ticketPhone}
          alt="Ticket"
          width={400}
          height={400}
          className="shadow-[0_0_18px_0_#0000000D]"
        /> */}

        <p className="typography-small-body-light text-grey-900 px-3 bg-green-50 rounded-xl inline-block mt-4">
          {/* Family With Kids */}
          {packageData?.category?.name} | {packageData?.package_type?.name}
        </p>
        <div className="flex flex-col md:flex-row items-left md:items-center gap-3 md:gap-10 mt-6">
          <p className="typography-sub-h1-regular font-medium">
            {packageData?.name}
          </p>
          <div className="flex flex-row gap-4 md:gap-8 typography-mid-body-light items-center">
            <p className="my-0"> 1 Country</p>
            <p className="my-0">
              {" "}
              {packageData?.city?.length ?? 0} Cities
            </p>☼ {packageData?.duration ?? 0} days
          </div>
        </div>
        <div className="typography-paragraph-extra-small text-blue-600 inline-flex gap-2 cursor-pointer mt-2">
          <MapPin size={15} />
          {packageData?.destination}
        </div>
        <div className="flex flex-row gap-5 md:gap-8 mt-6">
          {packageDetail.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center justify-center gap-2"
            >
              <item.icon size={20} className="text-grey-500" />
              <p className="typography-small-body-regular font-light text-grey-900 text-center">
                {item?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-2 flex flex-col items-start justify-center gap-2 lg:mr-[6rem] mr-5">
        <button className="border rounded-md md:px-4 md:py-1.5 py-3 items-center justify-center typography-large-body w-full md:w-auto border-green-200 inline-flex gap-3">
          <Ticket className="text-green-800" />{" "}
          <p className="text-green-600">Upto 10% off</p>
        </button>
        <div className="mt-2">
          <p className="typography-small-body-light text-grey-500 mb-1">
            Starting Price
          </p>
          <div className="inline-flex">
            <p className="typography-extra-large-body font-medium text-grey-700">
              NRP {packageData?.current_price} |-{" "}
              <span className="text-gray-300 line-through typography-mid-body font-light">
                NRP {packageData?.previous_price}
              </span>
            </p>
          </div>
        </div>
        {isLoggedIn ? (
          <Link href="/user/book/1">
            <button className="mt-2 bg-primary-500 hover:bg-primary-600 text-white md:typography-mid-body-medium typography-sub-h2-regular px-20 md:px-6 py-3 md:py-1.5 rounded-lg">
              Book Now
            </button>
          </Link>
        ) : (
          <div
            onClick={handleNotLoggedIn}
            className="mt-2 bg-primary-500 hover:bg-primary-600 text-white md:typography-mid-body-medium typography-sub-h2-regular px-20 md:px-6 py-3 md:py-1.5 rounded-lg"
          >
            Book Now
          </div>
        )}
        <div className="mt-2">
          <button className="inline-flex gap-2 typography-mid-body-medium text-grey-500 border border-grey-200 px-4 py-2 rounded-3xl">
            <Phone size={22} /> Enquire Now
          </button>
          <button className="inline-flex gap-2 typography-mid-body-medium border border-grey-200 p-1.5 rounded-full ml-4">
            <FaWhatsapp className="text-green-500" size={25} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookNowSection;
